export default __webpack_public_path__ + "static/media/review11.b70802a4.jpg";